import axios from 'axios';
import { url } from '../../config';

export const api = axios.create({
  baseURL: url,
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  async config => {
   const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers['x-access-token'] = `${token}`;
    }
    return config;
  },
  async error => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  async response => {
    return response;
  },
  async error => {
    return error.response;
  },
);

export default api;
